import { FormattedMessage, useIntl } from 'react-intl'
import { Page } from 'layouts/pages'
import Head from 'components/Head'
import { Main, Content, Header, Aside } from 'components/page'
import * as Layouts from 'layouts/glossary/layouts'
import * as Client from '@avcan/prismic/clients/glossary'
import * as Sidebar from 'components/sidebar'
import styles from 'layouts/glossary/Glossary.module.css'

export async function getStaticProps({ locale }) {
    const { layout, definitions } = await Client.getLayout('glossary', locale)

    if (!layout) {
        return {
            props: {
                layout: null,
                definitions: [],
                sections: [],
            },
        }
    }

    return {
        props: {
            layout,
            definitions,
            sections: Layouts.createSections(layout.data, definitions),
        },
    }
}

export default function Glossary(props) {
    return <Layouts.Glossary {...props} />
}

Glossary.getLayout = getLayout

export function getLayout(children) {
    return (
        <Page className={styles.Page}>
            <PageHeader />
            <Content>
                <Main>{children}</Main>
                <Aside>
                    <GlossarySidebar />
                </Aside>
            </Content>
        </Page>
    )
}

function PageHeader() {
    const intl = useIntl()
    const title = intl.formatMessage({
        description: 'Layout glossary/index',
        defaultMessage: 'Glossary',
    })
    return (
        <>
            <Head title={title} description={title} />
            <Header title={title} />
        </>
    )
}

function GlossarySidebar() {
    return (
        <Sidebar.default>
            <Sidebar.Header>
                <FormattedMessage description="Layout glossary/layouts" defaultMessage="Related links" />
            </Sidebar.Header>
            <Sidebar.Item>
                <a href="https://www.alpine-rescue.org/xCMS5/WebObjects/nexus5.woa/wa/icar?menuid=1088" target="ICAR">
                    <FormattedMessage description="Layout glossary/layouts" defaultMessage="ICAR Glossary" />
                </a>
            </Sidebar.Item>
            <Sidebar.Item>
                <a href="https://avalanche.ca/fxresources/AvalancheLexiqueLexicon.pdf" target="LexiqueLexicon">
                    <FormattedMessage
                        description="Layout glossary/layouts"
                        defaultMessage="Lexique Avalanche—Avalanche Lexicon"
                    />
                </a>
            </Sidebar.Item>
        </Sidebar.default>
    )
}
